import React, { useEffect, useState } from "react";
import styles from "./Media.module.scss";
import virtualProductionColor from "../../assets/images/virtualProductionColor.png";
import virtualProductionGray from "../../assets/images/virtualProductionGray.png";
import prolleyColor from "../../assets/images/prolleyColor.png";
import prolleyGray from "../../assets/images/prolleyGray.png";
import aptechLearningColor from "../../assets/images/aptechLearningColor.png";
import aptechLearningGray from "../../assets/images/aptechLearningGray.png";
import maacColor from "../../assets/images/maacColor.png";
import maacGray from "../../assets/images/maacGray.png";
import aptechAviationColor from "../../assets/images/aptechAviationColor.png";
import aptechAviationGray from "../../assets/images/aptechAviationGray.png";
import lakmeColor from "../../assets/images/lakmeColor.png";
import lakmeGray from "../../assets/images/lakmeColorLogo.png";
import preschoolColor from "../../assets/images/preschoolColor.png";
import preschoolGray from "../../assets/images/preschoolGray.png";
import aptechGlobalColor from "../../assets/images/AptechTrainingColorImg.png";
import aptechGlobalGray from "../../assets/images/AptechTrainingGrayImg.png";
import aptechAssessmentColor from "../../assets/images/aptechAssessmentColor.png";
import aptechAssessmentGray from "../../assets/images/aptechAssessmentGray.png";
import BreadCrumb from "../CommonComponents/BreadCrumb.tsx";
import AptechColorImg from "../../assets/images/AptechColorImg.png";
import AptechGrayImg from "../../assets/images/AptechGrayImg.png";
import ArenaColorImg from "../../assets/images/ArenaColorImg.png";
import ArenaGrayImg from "../../assets/images/ArenaGrayImg.png";
import { Icon } from "../../assets/Icons.tsx";
import { motion } from "framer-motion";
import EICColorLogo from "../../assets/images/EICColorLogo.jpg";
import EICGrayLogo from "../../assets/images/EICGrayLogo.jpg";
import avalonImage from "../../assets/images/avalonImage.png";
import avalonGray from "../../assets/images/avalonGray.png";

const cardData = [
  {
    text: "Aptech Corporate Logo",
    colorImage: AptechColorImg,
    grayImage: AptechGrayImg,
    viewColorLink:
      "https://www.aptech-worldwide.com/images/media-kit/big-logos/color/aptech_global_logo.jpg",
    viewGrayLink:
      "https://www.aptech-worldwide.com/images/media-kit/big-logos/black-n-white/aptech_global_logo.gif",
  },
  {
    text: "Arena Animation",
    colorImage: ArenaColorImg,
    grayImage: ArenaGrayImg,
    viewColorLink:
      "https://www.aptech-worldwide.com/images/media-kit/big-logos/color/arena_logo.jpg",
    viewGrayLink:
      "https://www.aptech-worldwide.com/images/media-kit/big-logos/black-n-white/arena_logo.jpg",
  },
  {
    text: "MAAC",
    colorImage: maacColor,
    grayImage: maacGray,
    viewColorLink:
      "https://www.aptech-worldwide.com/images/media-kit/big-logos/color/maac-logo-color.jpg",
    viewGrayLink:
      "https://www.aptech-worldwide.com/images/media-kit/big-logos/black-n-white/maac-logo-black.jpg",
  },
  {
    text: "Lakmē Academy powered by Aptech",
    colorImage: lakmeColor,
    grayImage: lakmeGray,
    viewColorLink:
      "https://www.aptech-worldwide.com/images/media-kit/big-logos/color/Lakme-Academy-logo-white-bg.jpg",
    viewGrayLink:
      "https://www.aptech-worldwide.com/images/media-kit/big-logos/black-n-white/Lakme-Academy-logo-black-bg.jpg",
  },
  {
    text: "Aptech Learning",
    colorImage: aptechLearningColor,
    grayImage: aptechLearningGray,
    viewColorLink:
      "https://www.aptech-worldwide.com/images/media-kit/big-logos/color/Aptech-Learning-logo.jpg",
    viewGrayLink:
      "https://www.aptech-worldwide.com/images/media-kit/big-logos/black-n-white/Aptech-Learning-logo-greyscale.jpg",
  },
  {
    text: "Avalon Academy",
    colorImage: avalonImage,
    grayImage: avalonGray,
    viewColorLink:
      "https://www.aptech-worldwide.com/images/media-kit/big-logos/color/avalon_logo.jpg",
    viewGrayLink:
      "https://www.aptech-worldwide.com/images/media-kit/big-logos/black-n-white/avalon_logo.jpg",
  },
  {
    text: "Aptech International Preschool",
    colorImage: preschoolColor,
    grayImage: preschoolGray,
    viewColorLink:
      "https://www.aptech-worldwide.com/images/media-kit/big-logos/color/AIP-logo-new-2.jpg",
    viewGrayLink:
      "https://www.aptech-worldwide.com/images/media-kit/big-logos/black-n-white/AIP-black-and-white-logo-new-2.jpg",
  },
  {
    text: "The Virtual Production Academy by Aptech",
    colorImage: virtualProductionColor,
    grayImage: virtualProductionGray,
    viewColorLink:
      "https://www.aptech-worldwide.com/images/media-kit/big-logos/color/TheVirtualProductionLogo_FINAL-01.png",
    viewGrayLink:
      "https://www.aptech-worldwide.com/images/media-kit/big-logos/black-n-white/The-Virtual-Production-Logo_Black.png",
  },
  {
    text: "ProAlley",
    colorImage: prolleyColor,
    grayImage: prolleyGray,
    viewColorLink:
      "https://www.aptech-worldwide.com/images/media-kit/big-logos/color/logo-ProAlley-Color-1.jpg",
    viewGrayLink:
      "https://www.aptech-worldwide.com/images/media-kit/big-logos/black-n-white/logo-ProAlley-Black-1.jpg",
  },
  {
    text: "Aptech Training Solutions",
    colorImage: aptechGlobalColor,
    grayImage: aptechGlobalGray,
    viewColorLink:
      "https://www.aptech-worldwide.com/images/media-kit/big-logos/color/ts_big.jpg",
    viewGrayLink:
      "https://www.aptech-worldwide.com/images/media-kit/big-logos/black-n-white/ts_big_bk.jpg",
  },
  {
    text: "Aptech Assessment & Testing Solutions",
    colorImage: aptechAssessmentColor,
    grayImage: aptechAssessmentGray,
    viewColorLink:
      "https://www.aptech-worldwide.com/images/media-kit/big-logos/color/attest_logo.gif",
    viewGrayLink:
      "https://www.aptech-worldwide.com/images/media-kit/big-logos/black-n-white/attest_logo.gif",
  },
  {
    text: "Education Institutes and Corporates (EIC) Unit",
    colorImage: EICColorLogo,
    grayImage: EICGrayLogo,
    viewColorLink:
      "https://www.aptech-worldwide.com/images/media-kit/big-logos/color/Education_Institutes_and_Corporates_Unit.png",
    viewGrayLink:
      "https://www.aptech-worldwide.com/images/media-kit/big-logos/black-n-white/Education_Institutes_and_Corporates_Unit_BW.png",
  },
];
const breadcrumb = [
  { title: "Home", link: "/" },
  { title: "News & Media", link: "/news-and-media" },
  { title: "Media Kit", link: "" },
];

const MediaKit = () => {
  const [isMobile, setIsMobile] = useState<boolean>(false);
  useEffect(() => {
    const updateView = () => {
      setIsMobile(window.innerWidth < 765);
    };
    updateView();
    window.addEventListener("resize", updateView);
    return () => window.removeEventListener("resize", updateView);
  }, []);
  const downloadFile = async (fileUrl, fileName) => {
    const url = fileUrl;

    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error("Failed to fetch the PDF file.");
      }
      const blob = await response.blob();
      const blobURL = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobURL;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobURL);
    } catch (error) {
      console.error("Error downloading the file:", error);
    }
  };

  return (
    <>
      <BreadCrumb menu={breadcrumb} />
      <motion.div
        initial={{ opacity: 0, y: 100 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, ease: "easeInOut" }}
      >
        <div className={`${styles.MediaKit} mt-5`}>
          <div className="container">
            <div className="section">
              <div className="row">
                <div className="col-12">
                  <h1 className="heading">Media kit</h1>
                  <p className="para">
                    Welcome to Aptech's Media Kit! All essential information
                    about <a href="/">Aptech</a>, a global leader in{" "}
                    <a href="/our-businesses/domestic-retail">
                      vocational training
                    </a>{" "}
                    and skill development, are listed here.{" "}
                  </p>
                  {/* <p className="para">
                  Gain a comprehensive view of Aptech Limited.
                </p> */}
                </div>
              </div>
              {!isMobile && (
                <>
                  <div className={styles.header}>
                    <div className="row">
                      <div className="col-6 col-lg-6 col-md-6 col-sm-5">
                        <p className="para">
                          <strong>Brand Name</strong>
                        </p>
                      </div>
                      <div className="col-3 col-lg-3 col-md-3 col-sm-4">
                        <p className="para">
                          <strong>Color</strong>
                        </p>
                      </div>
                      <div className="col-3 col-lg-3 col-md-3 col-sm-3">
                        <p className="para">
                          <strong>B & W</strong>
                        </p>
                      </div>
                    </div>
                  </div>

                  {cardData.map((card, index) => (
                    <div className={styles.brandCard} key={index}>
                      <div className="row">
                        <div className="col-6 col-lg-6 col-md-6 col-sm-5 ">
                          <p className="para mb-0">{card.text}</p>
                        </div>
                        <div
                          className={`col-3 col-lg-3 col-md-3 col-sm-4 ${styles.viewLinkDiv}`}
                        >
                          <a
                            href={card.viewColorLink}
                            style={{
                              fontSize: "24px",
                              cursor: "pointer",
                            }}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              src={card.colorImage}
                              className={styles.imageStyle}
                              alt=""
                            />
                          </a>
                          <div className="d-flex justify-content-center align-items-center">
                            {card?.viewColorLink && (
                              <span
                                style={{ cursor: "pointer" }}
                                className={styles.downloadIcon}
                                onClick={() =>
                                  downloadFile(
                                    card?.viewColorLink,
                                    `${card.text} color logo`
                                  )
                                }
                              >
                                <Icon
                                  name="circleDownArrow"
                                  height="30px"
                                  width="30px"
                                  color="#036995"
                                />{" "}
                              </span>
                            )}
                          </div>
                        </div>
                        <div
                          className={`col-3 col-lg-3 col-md-3 col-sm-3 ${styles.viewLinkDiv}`}
                        >
                          <a
                            href={card.viewGrayLink}
                            style={{
                              fontSize: "24px",
                              cursor: "pointer",
                            }}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              src={card.grayImage}
                              className={styles.imageStyle}
                              alt=""
                            />
                          </a>
                          <div className="d-flex justify-content-center align-items-center">
                            {card?.viewGrayLink && (
                              <span
                                className={styles.downloadIcon}
                                onClick={() =>
                                  downloadFile(
                                    card?.viewGrayLink,
                                    `${card.text} gray logo`
                                  )
                                }
                              >
                                <Icon
                                  name="circleDownArrow"
                                  height="30px"
                                  width="30px"
                                  color="#036995"
                                />{" "}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </>
              )}
              {isMobile && (
                <>
                  <div className={styles.header}>
                    <div className="row">
                      <div className="col-12 col-lg-12 col-md-12 col-sm-12">
                        <p className="para">
                          <strong>Brand Name</strong>
                        </p>
                      </div>
                    </div>
                  </div>

                  {cardData.map((card, index) => (
                    <div className={styles.brandCard} key={index}>
                      <div className="row">
                        <div className="col-12 col-lg-12 col-md-12 col-sm-12 ">
                          <p className="para mb-0 p-3">{card.text}</p>
                        </div>
                      </div>
                      <div className={`row ${styles.brandImagesDiv}`}>
                        <div className="col-6 d-flex flex-column justify-content-start align-items-start">
                          <p className="para caps p-0">
                            <strong>Color</strong>
                          </p>
                          <div className="d-flex justify-content-center align-items-center">
                            <a
                              href={card.viewColorLink}
                              style={{
                                fontSize: "24px",
                                cursor: "pointer",
                              }}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <img
                                src={card.colorImage}
                                className={styles.imageStyle}
                                alt=""
                              />
                            </a>

                            {card?.viewColorLink && (
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() =>
                                  downloadFile(
                                    card?.viewColorLink,
                                    `${card.text} color logo`
                                  )
                                }
                              >
                                <Icon
                                  name="circleDownArrow"
                                  height="30px"
                                  width="30px"
                                  color="#036995"
                                />{" "}
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="col-6 d-flex flex-column justify-content-start align-items-start">
                          <p className="para caps p-0">
                            <strong>B & W</strong>
                          </p>
                          <div className="d-flex justify-content-center align-items-center">
                            <a
                              href={card.viewGrayLink}
                              style={{
                                fontSize: "24px",
                                cursor: "pointer",
                              }}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <img
                                src={card.grayImage}
                                className={styles.imageStyle}
                                alt=""
                              />
                            </a>

                            {card?.viewGrayLink && (
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() =>
                                  downloadFile(
                                    card?.viewGrayLink,
                                    `${card.text} gray logo`
                                  )
                                }
                              >
                                <Icon
                                  name="circleDownArrow"
                                  height="30px"
                                  width="30px"
                                  color="#036995"
                                />{" "}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </>
              )}
            </div>
          </div>
        </div>
      </motion.div>
    </>
  );
};

export default MediaKit;
